import CryptoJS from "crypto-js";

/** Prefix for encrypted OnlyItemAtPrice query values (oip = only item at price). */
export var OIP_ENCRYPTED_PREFIX = "oip1.";

/** URL-safe transport wrapper: base64url(oip1.{ciphertext}). Avoids % encoding on QR / deep links. */
export var OIP_URL_BASE64_PREFIX = "oip1b.";
var PAYLOAD_PREFIX = "OnlyItemAtPrice=";

/**
 * @param {string} base64
 * @returns {string}
 */
export function toBase64Url(base64) {
  return base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

/**
 * @param {string} base64Url
 * @returns {string}
 */
export function fromBase64Url(base64Url) {
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var padding = base64.length % 4;
  if (padding) {
    base64 += "=".repeat(4 - padding);
  }
  return base64;
}

/**
 * @param {string} value
 * @returns {string}
 */
export function encodeOnlyItemAtPriceForUrl(value) {
  var base64 = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(value));
  return OIP_URL_BASE64_PREFIX + toBase64Url(base64);
}

/**
 * @param {string} urlValue
 * @returns {string|null}
 */
export function decodeOnlyItemAtPriceFromUrl(urlValue) {
  if (!urlValue || typeof urlValue !== "string") {
    return null;
  }
  var normalizedValue = urlValue.replace(/ /g, "+");
  if (normalizedValue.startsWith(OIP_URL_BASE64_PREFIX)) {
    var encoded = normalizedValue.slice(OIP_URL_BASE64_PREFIX.length);
    try {
      var base64 = fromBase64Url(encoded);
      var decoded = CryptoJS.enc.Utf8.stringify(CryptoJS.enc.Base64.parse(base64));
      return decoded || null;
    } catch (error) {
      return null;
    }
  }
  if (normalizedValue.startsWith(OIP_ENCRYPTED_PREFIX)) {
    return normalizedValue;
  }
  return null;
}

/**
 * @param {string} plaintext e.g. OnlyItemAtPrice=002146-18_003084-18
 * @param {string} key
 * @returns {string|null} OpenSSL-compatible AES ciphertext (base64)
 */
export function encryptOnlyItemAtPricePayload(plaintext, key) {
  if (!plaintext || !key) {
    return null;
  }
  return CryptoJS.AES.encrypt(plaintext, key).toString();
}

/**
 * @param {string} ciphertext
 * @param {string} key
 * @returns {string|null}
 */
export function decryptOnlyItemAtPricePayload(ciphertext, key) {
  if (!ciphertext || !key) {
    return null;
  }
  var normalizedCiphertext = ciphertext.replace(/ /g, "+");
  try {
    var bytes = CryptoJS.AES.decrypt(normalizedCiphertext, key);
    var decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return decrypted || null;
  } catch (error) {
    return null;
  }
}

/**
 * @param {string} itemsPlain e.g. 002146-18_003084-18
 * @param {string} key
 * @returns {string|null} Value for the OnlyItemAtPrice URL param
 */
export function buildOnlyItemAtPriceQueryValue(itemsPlain, key) {
  var plaintext = itemsPlain.startsWith(PAYLOAD_PREFIX) ? itemsPlain : PAYLOAD_PREFIX + itemsPlain;
  var encrypted = encryptOnlyItemAtPricePayload(plaintext, key);
  if (!encrypted) {
    return null;
  }
  return encodeOnlyItemAtPriceForUrl(OIP_ENCRYPTED_PREFIX + encrypted);
}

/**
 * @param {string} queryValue Full OnlyItemAtPrice param value
 * @param {string} key
 * @returns {string|null} Decrypted inner payload (without OnlyItemAtPrice= prefix)
 */
export function decryptOnlyItemAtPriceQueryValue(queryValue, key) {
  var innerValue = decodeOnlyItemAtPriceFromUrl(queryValue);
  if (!innerValue || !innerValue.startsWith(OIP_ENCRYPTED_PREFIX) || !key) {
    return null;
  }
  var ciphertext = innerValue.slice(OIP_ENCRYPTED_PREFIX.length);
  var decrypted = decryptOnlyItemAtPricePayload(ciphertext, key);
  if (!decrypted) {
    return null;
  }
  if (decrypted.startsWith(PAYLOAD_PREFIX)) {
    return decrypted.slice(PAYLOAD_PREFIX.length);
  }
  return decrypted;
}